import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { redMui } from "@ryde/theme";

export const DrawerFormWrapperStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drawer-form-wrapper",
})`
  padding-inline-end: 48px;
  padding-block-end: 24px;
  ul.errors-wrapper {
    width: 100%;
    border-radius: 6px;
    margin: 6px 0;
    list-style: none;

    .error-item {
      color: ${redMui._900};
      font-size: 14px;
      line-height: 1.4;
      padding-block: 6px;
      padding-inline-start: 8px;
      padding-inline-end: 7px;
      background: rgba(254, 215, 215, 0.3);
      border-radius: 5px;
      display: grid;
      grid-template-columns: 28px 1fr;
      align-items: center;
      .error-icon {
        justify-self: center;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
